import "./inputWithError.css";
import "./inputSearch.css";
import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";

export default class InputSearch extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired
  };

  static defaultProps = {
    type: "text"
  };

  constructor(props) {
    super(props);

    this.timeoutTime = 300;
    this.timeout = null;
  }

  componentDidUpdate(prevProps) {
    const {
      actions,
      feature,
      field,
      getDataFromServerAction,
      getDataFromServerActionParams,
      searchObj,
      cleanDataAction,
      resetPaginationPageAction,
      meta,
      notificationSystem
    } = this.props;
    if (prevProps.searchObj.get(field) !== searchObj.get(field)) {
      clearTimeout(this.timeout);
      let newSearchObj = searchObj.toJS();
      const sortObj = {
        field: "",
        isDirectionAscending: true
      };
      if (meta === "year") {
        if (newSearchObj[field].length >= 4) {
          this.timeout = setTimeout(() => {
            getDataFromServerAction();
          }, this.timeoutTime);
        } else {
          this.timeout = setTimeout(() => {
            getDataFromServerAction();
          }, this.timeoutTime);
        }
      } else {
        this.timeout = setTimeout(() => {
          getDataFromServerAction();
        }, this.timeoutTime);
      }
    }
  }

  onChange = ({ target: { value } }) => {
    const { actions, feature, field } = this.props;

    actions.setSearchField(feature, field, value);
  };

  render() {
    const { searchObj, field, type, onClick, className } = this.props;

    return (
      <div className="search-form">
        <input
          type={type}
          id={field}
          name={field}
          className={className}
          onChange={this.onChange}
          value={searchObj !== undefined ? searchObj.get(field) : ""}
          onClick={onClick}
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13.999px"
          height="13.999px"
        >
          <g>
            <path
              fill="#2980B9"
              d="M10.5,5.25C10.5,2.351,8.149,0,5.25,0S0,2.351,0,5.25c0,2.899,2.351,5.25,5.25,5.25S10.5,8.149,10.5,5.25zM5.25,9.187c-2.171,0-3.938-1.767-3.938-3.938S3.079,1.312,5.25,1.312S9.188,3.079,9.188,5.25S7.421,9.187,5.25,9.187zM13.615,11.759l-3.212-3.213c-0.479,0.744-1.112,1.378-1.856,1.856l3.212,3.212c0.513,0.512,1.344,0.512,1.856,0C14.127,13.103,14.127,12.271,13.615,11.759z"
            />
          </g>
        </svg>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/inputSearch.react.js